import { getParameterByName } from '../../components/common/hooks/useQuery';

export const getEnv = () => getParameterByName('env') ?? process.env.REACT_APP_INITIAL_ENV ?? 'dev';
